import React, { useEffect } from "react"
import Menu from './navbar'
import {Space} from 'antd';
import {useHistory, useLocation} from 'react-router-dom';
import {map, isArray} from 'lodash';
import {Button} from '@life-line-lab/components-react';
import { LanguageSelector } from '@life-line-lab/components-react';
import { useTranslation } from 'react-i18next';
import { useRefreshLanguageSettingState } from "Hooks/language-setting.hook";



const HorizontalNav = ({isAuth, menus, location}) =>{
    const history = useHistory();
    const reactRouterLocation = useLocation();
    const { i18n } = useTranslation();
    const [languageSetting, ] = useRefreshLanguageSettingState();

    const handleLanguageChange = (value: string) => {
        i18n.changeLanguage(value);
        localStorage.setItem("i18next", value);
        window.location.reload();
      }

    const languageOptions = [
      {
        label: 'English',
        initial: 'EN',
        value: 'en',
      },
      {
        label: 'Bahasa Melayu',
        initial: 'BM',
        value: 'ms',
      }
    ];


  // if user does not have i18n language in localStorage, set the default language, if is different from the app.
  useEffect(() => {
    const currentLanguage = localStorage.getItem('i18next');
    if (currentLanguage) return;

    if (!languageSetting) return;

    const foundEcomLanguageObj = languageSetting.languageSetting.find(s => s.site === process.env.ACCOUNT_TYPE);
    if (foundEcomLanguageObj) {
      const foundI18NLanguage = languageOptions.find(m => m.initial === foundEcomLanguageObj.defaultLanguage);
      if (foundI18NLanguage && foundI18NLanguage.value !== i18n.language) {
        handleLanguageChange(foundI18NLanguage.value);
      }
    }
  }, [languageSetting])

    return(
        <div>
           <Space direction="horizontal" size="small">
              {map(menus,(menu,i)=>{
                  if (menu.isButton) {
                    return (
                      <div key={i}>
                        {!isAuth &&
                          <Space direction="horizontal" size="large">
                            {location.pathname !== (menu.location) &&
                              <Button type={menu.type}
                                size="large"
                                label={menu.label}
                                onClick={()=>history.push(menu.href) }
                              />
                            }
                          </Space>
                        }
                      </div>
                    )
                  }
                  else if (menu.isLang) {
                    return (
                        <Space direction="horizontal" size="small">
                        <LanguageSelector
                          mode="short"
                          currentLanguage={i18n.language}
                          options={languageOptions}
                          onChange={handleLanguageChange}
                        />
                      </Space>
                    )
                }
                  else if (menu.href) {
                    return(
                      <div className="text" key={i} onClick={()=>history.push(menu.href)}>
                        {menu.label}
                      </div>
                    )
                  } else if (menu.customComponent) {
                    return (
                      <div key={i}>
                        {
                          (menu.hideIfLoggedIn && isAuth) ||
                          (isArray(menu.hideOnPath) && menu.hideOnPath.includes(reactRouterLocation.pathname)) ?
                            null :
                            menu.customComponent
                        }
                      </div>
                    )
                  }
                })
              }
           </Space>

        </div>
    )
}

export default HorizontalNav
